const dashboardHome = {
  activeProjects: "פרויקטים פעילים",
  documents: "מסמכים",
  avgHealth: "בריאות ממוצעת",
  todayEvents: "אירועי היום",
  recentProjects: "פרויקטים אחרונים",
  viewAll: "הכל",
  noProjects: "אין פרויקטים עדיין",
  noEvents: "אין אירועים להיום",
  quickActions: "פעולות מהירות",
  newProject: "פרויקט חדש",
  newDocument: "מסמך חדש",
  storyMap: "vStory",
  loadError: "שגיאה בטעינת נתונים",
  retry: "נסה שוב",
  entityTypes: "ישויות",
  recentEntities: "ישויות אחרונות",
  noEntities: "אין ישויות עדיין",
  items: "פריטים",
  docPipeline: "צינור מסמכים",
  docDrafts: "טיוטות",
  docPending: "ממתינים לחתימה",
  docSigned: "חתומים",
  docExpiring: "פג תוקף בקרוב",
} as const;
export default dashboardHome;
